import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBalanceSheetApi } from "../../../apiservice/reports";

export const fetchBalanceSheet = createAsyncThunk(
  "balanceSheet/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        selectedFilterType: filters?.filterType,
        type: "head_total",
      };
      if (filters?.filterType === "Financial Year") {
  payload.fyYear = filters?.fyYear; 
}
      if (filters?.filterType === "Date Wise") {
        // payload.fromDate = filters?.fromDate;
        payload.fromDate = null;
        payload.toDate = filters?.toDate;
      }

      const res = await getBalanceSheetApi(payload);
      const raw = res?.data ?? {};

      const suspenseBalance = raw.suspenseBalance ?? 0;

      const data = {
        // liabilities
        serviceBalance : raw.serviceBalance ?? 0 ,
        creditorBalance: raw.creditorBalance ?? 0,
        capitalBalance: raw.capitalBalance ?? 0,
        reserveSurplusBalance: raw.reserveSurplusBalance ?? 0,
        loanBalance: raw.loanBalance ?? 0,
        advanceDebtorBalance: raw.advanceDebtorBalance ?? 0,
        productTransferReceivedBalance: raw.productTransferReceivedBalance ?? 0,
        taxBalance: raw.taxBalance ?? 0, 
        cgstBalance: raw.cgstBalance ?? raw.cgst ?? 0,
        sgstBalance: raw.sgstBalance ?? raw.sgst ?? 0,
        igstBalance: raw.igstBalance ?? raw.igst ?? 0,
        currentLiabilityBalance: raw.currentLiabilityBalance ?? 0,
        profitLossBalance: raw.profitLossBalance ?? 0,
        diffOpeningBalance: raw.diffOpeningBalance ?? 0,
        retainedEarnings: raw.retainedEarnings ?? 0,
          balancingAdjustment: raw.balancingAdjustment ?? 0,
         suspenseBalance,
        liabilityTotal:
          (raw.creditorBalance ?? 0) +
          (raw.capitalBalance ?? 0) +
          (raw.reserveSurplusBalance ?? 0) +
          (raw.loanBalance ?? 0) +
          (raw.advanceDebtorBalance ?? 0) +
          (raw.productTransferReceivedBalance ?? 0) +
          (raw.taxBalance ?? 0) +
          (raw.currentLiabilityBalance ?? 0) +
          (raw.profitLossBalance ?? 0) +
          (raw.retainedEarnings ?? 0) +
          (raw.diffOpeningBalance ?? 0) +
          // serviceBalance is income -- already inside profitLossBalance / retainedEarnings.
            (raw.balancingAdjustment ?? 0) +
             (suspenseBalance < 0 ? Math.abs(suspenseBalance) : 0), 


        // assets
        cashBalance: raw.cashBalance ?? 0,
        bankBalance: raw.bankBalance ?? 0,
        debtorBalance: raw.debtorBalance ?? 0,
        fixedAssestsBalance: raw.fixedAssestsBalance ?? 0,
         intangibleAssetBalance: raw.intangibleAssetBalance ?? 0, 
        advanceCreditorBalance: raw.advanceCreditorBalance ?? 0,
        receiveableBranchAmount: raw.receiveableBranchAmount ?? 0,
        productTransferBalance: raw.productTransferBalance ?? 0,
        inventoryBalance: raw.inventoryBalance ?? 0,
        investmentBalance: raw.investmentBalance ?? 0,
        depositAccountBalance: raw.depositAccountBalance ?? 0,
        currentAssetsBalance: raw.currentAssetsBalance ?? 0,
        assetsTotal:
          (raw.cashBalance ?? 0) +
          (raw.bankBalance ?? 0) +
          (raw.debtorBalance ?? 0) +
          (raw.fixedAssestsBalance ?? 0) +
           (raw.intangibleAssetBalance ?? 0) + 
          (raw.advanceCreditorBalance ?? 0) +
          (raw.receiveableBranchAmount ?? 0) +
          (raw.productTransferBalance ?? 0) +
          (raw.inventoryBalance ?? 0) +
          (raw.investmentBalance ?? 0) +
          (raw.depositAccountBalance ?? 0) +
          (raw.currentAssetsBalance ?? 0)+
    (suspenseBalance > 0 ? suspenseBalance : 0),
      };

      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
